var GET_STARTED_API_ROUTES = {
    getStarted: '/api/teachers/groups/:groupId/getting_started',
    postPasswordsProvided: '/api/teachers/groups/:groupId/passwords_provided',
    downloadPasswords: '/teachers/g/:groupId/download-passwords',
};
export { GET_STARTED_API_ROUTES };
